import { render, staticRenderFns } from "./SaveFormProfileRelease.vue?vue&type=template&id=468e27dd"
import script from "./SaveFormProfileRelease.vue?vue&type=script&lang=js"
export * from "./SaveFormProfileRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports